export const LOTTERY_TABS = [
    { value: "mt", label: "MT" },
    { value: "mc", label: "MC" },
    { value: "tc", label: "TC" },
    { value: "kp", label: "KP" },
    { value: "kh", label: "KH" },
    { value: "sc", label: "SC" },
    { value: "leap", label: "LEAP" },
];
